export const getAppVersion = () => {
  return process.env.VUE_APP_VERSION;
};

export const getPhotocellUrl = () => {
  return process.env.VUE_APP_URL_PHOTOCELL;
};

export const getMDXWaterUrl = () => {
  return process.env.VUE_APP_URL_MDX_WATER;
};

